import { render } from "./SettingsBoard.vue?vue&type=template&id=3a7bd541&scoped=true"
import script from "./SettingsBoard.vue?vue&type=script&lang=js"
export * from "./SettingsBoard.vue?vue&type=script&lang=js"

import "./SettingsBoard.vue?vue&type=style&index=0&id=3a7bd541&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7bd541"]])

export default __exports__